import { useQuery } from 'react-query';
import { FeaturesMap } from 'global';
import { PET_PROFILE_A_URL } from './config';
import { clientOptionsRefetch } from './reactQueryOptions';
import log from './log';

export interface FeatureInterface {
  name: string;
  value: string;
}

type FeatureRequest = string;

const FEATURE_CONFIG_ENDPOINT = `${PET_PROFILE_A_URL}/api/petprofile/v1/featureConfig`;

const getFeatureConfigEndpoint = (feature: FeatureRequest = ''): string =>
  // Feature Request is always an array of strings, even when only one item is required
  `${FEATURE_CONFIG_ENDPOINT}?configKey=${feature}`;

const generateLoadDataFn = (path: string) => async (): Promise<FeaturesMap | undefined> => {
  try {
    const response = await fetch(path);
    if (response.ok) {
      const data = await response.json();
      const featuresMap: FeaturesMap = data.reduce((acc: FeaturesMap, curr: FeatureInterface) => {
        acc[curr.name] = curr.value;
        return acc;
      }, {});
      return featuresMap;
    }
    log.warn(`Unexpected ${response.status} response from server - ${response.statusText}`);
    return;
  } catch (error) {
    log.error(`Failed to fetch user data from ${FEATURE_CONFIG_ENDPOINT}`, error);
  }
};

const useFeature = (feature: FeatureRequest = '') => {
  const requestPath = getFeatureConfigEndpoint(feature);
  return useQuery<FeaturesMap | undefined>(
    requestPath,
    generateLoadDataFn(requestPath),
    clientOptionsRefetch,
  );
};

export {
  useFeature as default,
  getFeatureConfigEndpoint,
  generateLoadDataFn,
  FEATURE_CONFIG_ENDPOINT,
};
